import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=46b7f6c7"
import script from "./Uploader.vue?vue&type=script&setup=true&lang=js"
export * from "./Uploader.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports